/**
 * this data is a subset of emojis available at
 * https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/elements/util-data-test/src/json-data/emoji-all.json
 *
 * this file is also exported and used by `@canvas/spritesheet`
 */
export const emojis = [
  {
    id: '1f600',
    name: 'grinning face',
    fallback: '😀',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11103,
    representation: {
      x: 0,
      y: 0,
      height: 64,
      width: 64,
      xIndex: 0,
      yIndex: 0,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':grinning:',
  },
  {
    id: '1f603',
    name: 'grinning face with big eyes',
    fallback: '😃',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11104,
    representation: {
      x: 66,
      y: 0,
      height: 64,
      width: 64,
      xIndex: 1,
      yIndex: 0,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    ascii: [':D', ':-D', '=D'],
    searchable: true,
    shortName: ':smiley:',
  },
  {
    id: '1f604',
    name: 'grinning face with smiling eyes',
    fallback: '😄',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11105,
    representation: {
      x: 132,
      y: 0,
      height: 64,
      width: 64,
      xIndex: 2,
      yIndex: 0,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':smile:',
  },
  {
    id: '1f601',
    name: 'beaming face with smiling eyes',
    fallback: '😁',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11106,
    representation: {
      x: 198,
      y: 0,
      height: 64,
      width: 64,
      xIndex: 3,
      yIndex: 0,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':grin:',
  },
  {
    id: '1f606',
    name: 'grinning squinting face',
    fallback: '😆',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11107,
    representation: {
      x: 264,
      y: 0,
      height: 64,
      width: 64,
      xIndex: 4,
      yIndex: 0,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    ascii: ['>:)', '>;)', '>:-)', '>=)'],
    searchable: true,
    shortName: ':laughing:',
  },
  {
    id: '1f605',
    name: 'grinning face with sweat',
    fallback: '😅',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11108,
    representation: {
      x: 330,
      y: 0,
      height: 64,
      width: 64,
      xIndex: 5,
      yIndex: 0,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    ascii: ["':)", "':-)", "'=)", "':D", "':-D", "'=D"],
    searchable: true,
    shortName: ':sweat_smile:',
  },
  {
    id: '1f602',
    name: 'face with tears of joy',
    fallback: '😂',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11109,
    representation: {
      x: 396,
      y: 0,
      height: 64,
      width: 64,
      xIndex: 6,
      yIndex: 0,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    ascii: [":')", ":'-)"],
    searchable: true,
    shortName: ':joy:',
  },
  {
    id: '1f923',
    name: 'rolling on the floor laughing',
    fallback: '🤣',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11110,
    representation: {
      x: 462,
      y: 0,
      height: 64,
      width: 64,
      xIndex: 7,
      yIndex: 0,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':rofl:',
  },
  {
    id: '263a',
    name: 'smiling face',
    fallback: '\u263a',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11111,
    representation: {
      x: 528,
      y: 0,
      height: 64,
      width: 64,
      xIndex: 8,
      yIndex: 0,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':relaxed:',
  },
  {
    id: '1f60a',
    name: 'smiling face with smiling eyes',
    fallback: '😊',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11112,
    representation: {
      x: 594,
      y: 0,
      height: 64,
      width: 64,
      xIndex: 9,
      yIndex: 0,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':blush:',
  },
  {
    id: '2764',
    name: 'red heart',
    fallback: '\u2764',
    type: 'STANDARD',
    category: 'SYMBOLS',
    order: 11113,
    representation: {
      x: 0,
      y: 0,
      height: 64,
      width: 64,
      xIndex: 0,
      yIndex: 0,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/symbols.png',
    },
    searchable: true,
    shortName: ':heart:',
  },
  {
    id: '1f44d',
    name: 'thumbs up',
    fallback: '👍',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11114,
    representation: {
      x: 1655,
      y: 198,
      height: 64,
      width: 64,
      xIndex: 25,
      yIndex: 3,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':thumbsup:',
  },
  {
    id: '1f62d',
    name: 'loudly crying face',
    fallback: '😭',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11115,
    representation: {
      x: 528,
      y: 66,
      height: 64,
      width: 64,
      xIndex: 8,
      yIndex: 1,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':cry:',
  },
  {
    id: '1f64f',
    name: 'folded hands',
    fallback: '🙏',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11116,
    representation: {
      x: 132,
      y: 528,
      width: 64,
      height: 64,
      xIndex: 2,
      yIndex: 8,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':pray:',
  },
  {
    id: '1f618',
    name: 'face blowing a kiss',
    fallback: '😘',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11116,
    representation: {
      x: 1056,
      y: 0,
      width: 64,
      height: 64,
      xIndex: 16,
      yIndex: 0,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':kissing-heart:',
  },
  {
    id: '1f970',
    name: 'smiling face with hearts',
    fallback: '🥰',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11117,
    representation: {
      x: 1122,
      y: 0,
      width: 64,
      height: 64,
      xIndex: 17,
      yIndex: 0,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':smiling-face-with-hearts:',
  },
  {
    id: '1f60d',
    name: 'smiling face with heart-eyes',
    fallback: '😍',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11117,
    representation: {
      x: 990,
      y: 0,
      width: 64,
      height: 64,
      xIndex: 15,
      yIndex: 0,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':smiling-face-with-heart-eyes:',
  },
  {
    id: '1f389',
    name: 'party-popper',
    fallback: '🎉',
    type: 'STANDARD',
    category: 'OBJECTS',
    order: 11118,
    representation: {
      x: 858,
      y: 528,
      width: 64,
      height: 64,
      xIndex: 13,
      yIndex: 8,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/objects.png',
    },
    searchable: true,
    shortName: ':party-popper:',
  },
  {
    id: '1f495',
    name: 'two-hearts',
    fallback: '💕',
    type: 'STANDARD',
    category: 'SYMBOLS',
    order: 11119,
    representation: {
      x: 594,
      y: 0,
      width: 64,
      height: 64,
      xIndex: 9,
      yIndex: 0,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/symbols.png',
    },
    searchable: true,
    shortName: ':two_hearts:',
  },
  {
    id: '1f97a',
    name: 'pleading-face',
    fallback: '🥺',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11120,
    representation: {
      x: 1320,
      y: 66,
      width: 64,
      height: 64,
      xIndex: 20,
      yIndex: 1,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':pleading-face:',
  },
  {
    id: '1f525',
    name: 'fire',
    fallback: '🔥',
    type: 'STANDARD',
    category: 'NATURE',
    order: 11121,
    representation: {
      x: 858,
      y: 660,
      width: 64,
      height: 64,
      xIndex: 13,
      yIndex: 10,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/nature.png',
    },
    searchable: true,
    shortName: ':fire:',
  },
  {
    id: '1f926',
    name: 'person facepalming',
    fallback: '🤦',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11122,
    representation: {
      x: 264,
      y: 1848,
      width: 64,
      height: 64,
      xIndex: 4,
      yIndex: 28,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':facepalm:',
  },
  {
    id: '1f5a4',
    name: 'heart suit',
    fallback: '🖤',
    type: 'STANDARD',
    category: 'SYMBOLS',
    order: 11123,
    representation: {
      x: 396,
      y: 0,
      width: 64,
      height: 64,
      xIndex: 6,
      yIndex: 0,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/symbols.png',
    },
    searchable: true,
    shortName: ':heart-suit:',
  },
  {
    id: '1f937',
    name: 'person shrugging',
    fallback: '🤷',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11124,
    representation: {
      x: 924,
      y: 1848,
      width: 64,
      height: 64,
      xIndex: 14,
      yIndex: 28,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':shrug:',
  },
  {
    id: '1f644',
    name: 'face with rolling eyes',
    fallback: '🙄',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11125,
    representation: {
      x: 2112,
      y: 66,
      width: 64,
      height: 64,
      xIndex: 32,
      yIndex: 1,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':rolling-eyes:',
  },
  {
    id: '1f917',
    name: 'hugging face',
    fallback: '🤗',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11127,
    representation: {
      x: 1518,
      y: 66,
      width: 64,
      height: 64,
      xIndex: 23,
      yIndex: 1,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':hugging-face:',
  },
  {
    id: '1f609',
    name: 'winking face',
    fallback: '😉',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11128,
    representation: {
      x: 858,
      y: 0,
      width: 64,
      height: 64,
      xIndex: 13,
      yIndex: 0,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':winking-face:',
  },
  {
    id: '1f382',
    name: 'cake',
    fallback: '🎂',
    type: 'STANDARD',
    category: 'FOODS',
    order: 11129,
    representation: {
      x: 264,
      y: 396,
      width: 64,
      height: 64,
      xIndex: 4,
      yIndex: 6,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/foods.png',
    },
    searchable: true,
    shortName: ':cake:',
  },
  {
    id: '1f914',
    name: 'thinking face',
    fallback: '🤔',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11130,
    representation: {
      x: 1584,
      y: 66,
      width: 64,
      height: 64,
      xIndex: 24,
      yIndex: 1,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':thinking:',
  },
  {
    id: '1f44f',
    name: 'clapping hands',
    fallback: '👏',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11131,
    representation: {
      x: 1188,
      y: 198,
      width: 64,
      height: 64,
      xIndex: 18,
      yIndex: 3,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':clap:',
  },
  {
    id: '1f642',
    name: 'slightly smiling face',
    fallback: '🙂',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11132,
    representation: {
      x: 726,
      y: 0,
      width: 64,
      height: 64,
      xIndex: 11,
      yIndex: 0,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':smile:',
  },
  {
    id: '1f633',
    name: 'flushed face',
    fallback: '😳',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11133,
    representation: {
      x: 924,
      y: 66,
      width: 64,
      height: 64,
      xIndex: 14,
      yIndex: 1,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':flushed:',
  },
  {
    id: '1f973',
    name: 'partying face',
    fallback: '🥳',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11134,
    representation: {
      x: 2046,
      y: 0,
      width: 64,
      height: 64,
      xIndex: 31,
      yIndex: 0,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':partying:',
  },
  {
    id: '1f60e',
    name: 'smiling face with sunglasses',
    fallback: '😎',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11135,
    representation: {
      x: 1914,
      y: 0,
      width: 64,
      height: 64,
      xIndex: 29,
      yIndex: 0,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':sunglasses:',
  },
  {
    id: '1f44c',
    name: 'OK hand',
    fallback: '👌',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11136,
    representation: {
      x: 726,
      y: 330,
      width: 64,
      height: 64,
      xIndex: 11,
      yIndex: 5,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':ok:',
  },
  {
    id: '1f49c',
    name: 'purple heart',
    fallback: '💜',
    type: 'STANDARD',
    category: 'SYMBOL',
    order: 11137,
    representation: {
      x: 330,
      y: 0,
      width: 64,
      height: 64,
      xIndex: 5,
      yIndex: 0,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/symbols.png',
    },
    searchable: true,
    shortName: ':purple-heart:',
  },
  {
    id: '1f614',
    name: 'pensive face',
    fallback: '😔',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11138,
    representation: {
      x: 2310,
      y: 0,
      width: 64,
      height: 64,
      xIndex: 35,
      yIndex: 0,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':pensive-face:',
  },
  {
    id: '1f4aa',
    name: 'flexed biceps',
    fallback: '💪',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11139,
    representation: {
      x: 594,
      y: 462,
      width: 64,
      height: 64,
      xIndex: 9,
      yIndex: 7,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':flexed-biceps:',
  },
  {
    id: '2728',
    name: 'sparkles',
    fallback: '✨',
    type: 'STANDARD',
    category: 'NATURE',
    order: 11140,
    representation: {
      x: 594,
      y: 660,
      width: 64,
      height: 64,
      xIndex: 9,
      yIndex: 10,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/nature.png',
    },
    searchable: true,
    shortName: ':sparkles:',
  },
  {
    id: '1f496',
    name: 'sparkling heart',
    fallback: '💖',
    type: 'STANDARD',
    category: 'SYMBOLS',
    order: 11141,
    representation: {
      x: 858,
      y: 0,
      width: 64,
      height: 64,
      xIndex: 13,
      yIndex: 0,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/symbols.png',
    },
    searchable: true,
    shortName: ':sparkling-heart:',
  },
  {
    id: '1f440',
    name: 'eyes',
    fallback: '👀',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11142,
    representation: {
      x: 1782,
      y: 528,
      width: 64,
      height: 64,
      xIndex: 27,
      yIndex: 8,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':eyes:',
  },
  {
    id: '1f60b',
    name: 'face savoring food',
    fallback: '😋',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11143,
    representation: {
      x: 1386,
      y: 0,
      width: 64,
      height: 64,
      xIndex: 21,
      yIndex: 0,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':savoring-food:',
  },
  {
    id: '1f60f',
    name: 'smirking face',
    fallback: '😏',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11144,
    representation: {
      x: 2112,
      y: 0,
      width: 64,
      height: 64,
      xIndex: 32,
      yIndex: 0,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':smirk:',
  },
  {
    id: '1f622',
    name: 'crying face',
    fallback: '😢',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11145,
    representation: {
      x: 462,
      y: 66,
      width: 64,
      height: 64,
      xIndex: 7,
      yIndex: 1,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':cry:',
  },
  {
    id: '1f449',
    name: 'backhand index pointing right',
    fallback: '👉',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11146,
    representation: {
      x: 1518,
      y: 330,
      width: 64,
      height: 64,
      xIndex: 23,
      yIndex: 5,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':index-point:',
  },
  {
    id: '1f497',
    name: 'growing heart',
    fallback: '💗',
    type: 'STANDARD',
    category: 'SYMBOLS',
    order: 11147,
    representation: {
      x: 792,
      y: 0,
      width: 64,
      height: 64,
      xIndex: 12,
      yIndex: 0,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/symbols.png',
    },
    searchable: true,
    shortName: ':growing-heart:',
  },
  {
    id: '1f629',
    name: 'weary face',
    fallback: '😩',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11148,
    representation: {
      x: 396,
      y: 66,
      width: 64,
      height: 64,
      xIndex: 6,
      yIndex: 1,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':weary-face:',
  },
  {
    id: '1f4af',
    name: 'hundred points',
    fallback: '💯',
    type: 'STANDARD',
    category: 'SYMBOL',
    order: 11149,
    representation: {
      x: 0,
      y: 264,
      width: 64,
      height: 64,
      xIndex: 0,
      yIndex: 4,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/symbols.png',
    },
    searchable: true,
    shortName: ':hundred-points:',
  },
  {
    id: '1f339',
    name: 'rose',
    fallback: '🌹',
    type: 'STANDARD',
    category: 'NATURE',
    order: 11150,
    representation: {
      x: 726,
      y: 528,
      width: 64,
      height: 64,
      xIndex: 11,
      yIndex: 8,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/nature.png',
    },
    searchable: true,
    shortName: ':rose:',
  },
  {
    id: '1f49e',
    name: 'revolving hearts',
    fallback: '💞',
    type: 'STANDARD',
    category: 'SYMBOLS',
    order: 11151,
    representation: {
      x: 660,
      y: 0,
      width: 64,
      height: 64,
      xIndex: 10,
      yIndex: 0,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/symbols.png',
    },
    searchable: true,
    shortName: ':revolving-hearts:',
  },
  {
    id: '1f388',
    name: 'balloon',
    fallback: '🎈',
    type: 'STANDARD',
    category: 'OBJECTS',
    order: 11151,
    representation: {
      x: 594,
      y: 528,
      width: 64,
      height: 64,
      xIndex: 9,
      yIndex: 8,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/objects.png',
    },
    searchable: true,
    shortName: ':balloon:',
  },
  {
    id: '1f499',
    name: 'blue heart',
    fallback: '💙',
    type: 'STANDARD',
    category: 'SYMBOLS',
    order: 11152,
    representation: {
      x: 264,
      y: 0,
      width: 64,
      height: 64,
      xIndex: 4,
      yIndex: 0,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/symbols.png',
    },
    searchable: true,
    shortName: ':blue-heart:',
  },
  {
    id: '1f621',
    name: 'pouting face',
    fallback: '😡',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11153,
    representation: {
      x: 726,
      y: 66,
      width: 64,
      height: 64,
      xIndex: 11,
      yIndex: 1,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':pouting:',
  },
  {
    id: '1f490',
    name: 'bouquet',
    fallback: '💐',
    type: 'STANDARD',
    category: 'NATURE',
    order: 11154,
    representation: {
      x: 594,
      y: 528,
      width: 64,
      height: 64,
      xIndex: 9,
      yIndex: 8,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/nature.png',
    },
    searchable: true,
    shortName: ':bouquet:',
  },
  {
    id: '1f61c',
    name: 'winking face with tongue',
    fallback: '😜',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11155,
    representation: {
      x: 1584,
      y: 0,
      width: 64,
      height: 64,
      xIndex: 24,
      yIndex: 0,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':wink-tongue:',
  },
  {
    id: '1f648',
    name: 'see-no-evil monkey',
    fallback: '🙈',
    type: 'STANDARD',
    category: 'NATURE',
    order: 11156,
    representation: {
      x: 330,
      y: 66,
      width: 64,
      height: 64,
      xIndex: 5,
      yIndex: 1,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/nature.png',
    },
    searchable: true,
    shortName: ':monkey:',
  },
  {
    id: '1f91e',
    name: 'crossed fingers',
    fallback: '🤞',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11157,
    representation: {
      x: 1584,
      y: 264,
      width: 64,
      height: 64,
      xIndex: 24,
      yIndex: 4,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':crossed-fingers:',
  },
  {
    id: '1f924',
    name: 'drooling face',
    fallback: '🤤',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11158,
    representation: {
      x: 132,
      y: 132,
      width: 64,
      height: 64,
      xIndex: 2,
      yIndex: 2,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':drooling:',
  },
  {
    id: '1f64c',
    name: 'raising hands',
    fallback: '🙌',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11159,
    representation: {
      x: 792,
      y: 198,
      width: 64,
      height: 64,
      xIndex: 12,
      yIndex: 3,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':raising-hands:',
  },
  {
    id: '1f92a',
    name: 'zany face',
    fallback: '🤪',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11160,
    representation: {
      x: 1650,
      y: 0,
      width: 64,
      height: 64,
      xIndex: 25,
      yIndex: 0,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':zany-face:',
  },
  {
    id: '2763',
    name: 'heart exclamation',
    fallback: '\u2763',
    type: 'STANDARD',
    category: 'SYMBOLS',
    order: 11161,
    representation: {
      x: 528,
      y: 0,
      width: 64,
      height: 64,
      xIndex: 8,
      yIndex: 0,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/symbols.png',
    },
    searchable: true,
    shortName: ':heart-exclamation:',
  },
  {
    id: '1f48b',
    name: 'kiss mark',
    fallback: '💋',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11162,
    representation: {
      x: 660,
      y: 528,
      width: 64,
      height: 64,
      xIndex: 10,
      yIndex: 8,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':kiss:',
  },
  {
    id: '1f480',
    name: 'skull',
    fallback: '💀',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11163,
    representation: {
      x: 1452,
      y: 132,
      width: 64,
      height: 64,
      xIndex: 22,
      yIndex: 2,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':skull:',
  },
  {
    id: '1f447',
    name: 'backhand index pointing down',
    fallback: '👇',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11164,
    representation: {
      x: 2310,
      y: 330,
      width: 64,
      height: 64,
      xIndex: 35,
      yIndex: 5,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':index-down:',
  },
  {
    id: '1f494',
    name: 'broken heart',
    fallback: '💔',
    type: 'STANDARD',
    category: 'SYMBOLS',
    order: 11165,
    representation: {
      x: 462,
      y: 0,
      width: 64,
      height: 64,
      xIndex: 7,
      yIndex: 0,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/symbols.png',
    },
    searchable: true,
    shortName: ':broken-heart:',
  },
  {
    id: '1f60c',
    name: 'relieved face',
    fallback: '😌',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11166,
    representation: {
      x: 924,
      y: 0,
      width: 64,
      height: 64,
      xIndex: 14,
      yIndex: 0,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':relieved:',
  },
  {
    id: '1f493',
    name: 'beating heart',
    fallback: '💓',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11167,
    representation: {
      x: 726,
      y: 0,
      width: 64,
      height: 64,
      xIndex: 11,
      yIndex: 0,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/symbols.png',
    },
    searchable: true,
    shortName: ':beating-heart:',
  },
  {
    id: '1f929',
    name: 'star-struck',
    fallback: '🤩',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11168,
    representation: {
      x: 1980,
      y: 0,
      width: 64,
      height: 64,
      xIndex: 30,
      yIndex: 0,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':star-struck:',
  },
  {
    id: '1f62c',
    name: 'grimacing face',
    fallback: '😬',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11170,
    representation: {
      x: 2046,
      y: 66,
      width: 64,
      height: 64,
      xIndex: 31,
      yIndex: 1,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':grimacing:',
  },
  {
    id: '1f631',
    name: 'face screaming in fear',
    fallback: '😱',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11171,
    representation: {
      x: 990,
      y: 66,
      width: 64,
      height: 64,
      xIndex: 15,
      yIndex: 1,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':scream:',
  },
  {
    id: '1f634',
    name: 'sleeping face',
    fallback: '😴',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11172,
    representation: {
      x: 66,
      y: 132,
      width: 64,
      height: 64,
      xIndex: 1,
      yIndex: 2,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':sleeping:',
  },
  {
    id: '1f92d',
    name: 'face with hand over mouth',
    fallback: '🤭',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11173,
    representation: {
      x: 1650,
      y: 66,
      width: 64,
      height: 64,
      xIndex: 25,
      yIndex: 1,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':face-mouth-cover:',
  },
  {
    id: '1f610',
    name: 'neutral face',
    fallback: '😐',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11174,
    representation: {
      x: 1914,
      y: 66,
      width: 64,
      height: 64,
      xIndex: 29,
      yIndex: 1,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':neutral:',
  },
  {
    id: '1f31e',
    name: 'sun with face',
    fallback: '🌞',
    type: 'STANDARD',
    category: 'NATURE',
    order: 11175,
    representation: {
      x: 198,
      y: 594,
      width: 64,
      height: 64,
      xIndex: 3,
      yIndex: 9,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/nature.png',
    },
    searchable: true,
    shortName: ':sun-face:',
  },
  {
    id: '1f612',
    name: 'unamused face',
    fallback: '😒',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11176,
    representation: {
      x: 2178,
      y: 0,
      width: 64,
      height: 64,
      xIndex: 33,
      yIndex: 0,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':unamused:',
  },
  {
    id: '1f607',
    name: 'smiling face with halo',
    fallback: '😇',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11177,
    representation: {
      x: 660,
      y: 0,
      width: 64,
      height: 64,
      xIndex: 10,
      yIndex: 0,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':smiling-halo:',
  },
  {
    id: '1f338',
    name: 'cherry blossom',
    fallback: '🌸',
    type: 'STANDARD',
    category: 'NATURE',
    order: 11178,
    representation: {
      x: 0,
      y: 594,
      width: 64,
      height: 64,
      xIndex: 0,
      yIndex: 9,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/nature.png',
    },
    searchable: true,
    shortName: ':cherry-blossom:',
  },
  {
    id: '1f608',
    name: 'smiling face with horns',
    fallback: '😈',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11179,
    representation: {
      x: 990,
      y: 132,
      width: 64,
      height: 64,
      xIndex: 15,
      yIndex: 2,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':smiling-horns:',
  },
  {
    id: '1f3b6',
    name: 'musical notes',
    fallback: '🎶',
    type: 'STANDARD',
    category: 'SYMBOLs',
    order: 11180,
    representation: {
      x: 0,
      y: 660,
      width: 64,
      height: 64,
      xIndex: 0,
      yIndex: 10,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/symbols.png',
    },
    searchable: true,
    shortName: ':music:',
  },
  {
    id: '270c',
    name: 'victory hand',
    fallback: '\u270c',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11181,
    representation: {
      x: 1980,
      y: 264,
      width: 64,
      height: 64,
      xIndex: 30,
      yIndex: 4,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':victory:',
  },
  {
    id: '1f38a',
    name: 'confetti ball',
    fallback: '🎊',
    type: 'STANDARD',
    category: 'OBJECTS',
    order: 11182,
    representation: {
      x: 792,
      y: 528,
      width: 64,
      height: 64,
      xIndex: 12,
      yIndex: 8,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/objects.png',
    },
    searchable: true,
    shortName: ':confetti:',
  },
  {
    id: '1f975',
    name: 'hot face',
    fallback: '🥵',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11183,
    representation: {
      x: 1188,
      y: 66,
      width: 64,
      height: 64,
      xIndex: 18,
      yIndex: 1,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':hot:',
  },
  {
    id: '1f61e',
    name: 'disappointed face',
    fallback: '😞',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11183,
    representation: {
      x: 2244,
      y: 0,
      width: 64,
      height: 64,
      xIndex: 34,
      yIndex: 0,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':disappointed:',
  },
  {
    id: '1f49a',
    name: 'green heart',
    fallback: '💚',
    type: 'STANDARD',
    category: 'SYMBOLS',
    order: 11184,
    representation: {
      x: 198,
      y: 0,
      width: 64,
      height: 64,
      xIndex: 3,
      yIndex: 0,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/symbols.png',
    },
    searchable: true,
    shortName: ':green-heart:',
  },
  {
    id: '2600',
    name: 'sun',
    fallback: '\u2600',
    type: 'STANDARD',
    category: 'NATURE',
    order: 11185,
    representation: {
      x: 132,
      y: 726,
      width: 64,
      height: 64,
      xIndex: 2,
      yIndex: 11,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/nature.png',
    },
    searchable: true,
    shortName: ':sun:',
  },
  {
    id: '1f4b0',
    name: 'money bag',
    fallback: '💰',
    type: 'STANDARD',
    category: 'OBJECTS',
    order: 11187,
    representation: {
      x: 660,
      y: 198,
      width: 64,
      height: 64,
      xIndex: 10,
      yIndex: 3,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/objects.png',
    },
    searchable: true,
    shortName: ':money:',
  },
  {
    id: '1f61a',
    name: 'kissing face with closed eyes',
    fallback: '😚',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11188,
    representation: {
      x: 1320,
      y: 0,
      width: 64,
      height: 64,
      xIndex: 20,
      yIndex: 0,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':kissing-face:',
  },
  {
    id: '1f451',
    name: 'crown',
    fallback: '👑',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11189,
    representation: {
      x: 1980,
      y: 2244,
      width: 64,
      height: 64,
      xIndex: 30,
      yIndex: 34,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':crown:',
  },
  {
    id: '1f381',
    name: 'wrapped gift',
    fallback: '🎁',
    type: 'STANDARD',
    category: 'OBJECTS',
    order: 11190,
    representation: {
      x: 528,
      y: 528,
      width: 64,
      height: 64,
      xIndex: 8,
      yIndex: 8,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/objects.png',
    },
    searchable: true,
    shortName: ':gift:',
  },
  {
    id: '1f4a5',
    name: 'collision',
    fallback: '💥',
    type: 'STANDARD',
    category: 'NATURE',
    order: 11191,
    representation: {
      x: 792,
      y: 660,
      width: 64,
      height: 64,
      xIndex: 12,
      yIndex: 10,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/nature.png',
    },
    searchable: true,
    shortName: ':collision:',
  },
  {
    id: '1f64b',
    name: 'person raising hand',
    fallback: '🙋',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11192,
    representation: {
      x: 990,
      y: 1782,
      width: 64,
      height: 64,
      xIndex: 15,
      yIndex: 27,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':raising-hand:',
  },
  {
    id: '2639',
    name: 'frowning face',
    fallback: '\u2639',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11193,
    representation: {
      x: 132,
      y: 66,
      width: 64,
      height: 64,
      xIndex: 2,
      yIndex: 1,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':frowning:',
  },
  {
    id: '1f611',
    name: 'expressionless face',
    fallback: '😑',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11194,
    representation: {
      x: 1980,
      y: 66,
      width: 64,
      height: 64,
      xIndex: 30,
      yIndex: 1,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':expressionless:',
  },
  {
    id: '1f974',
    name: 'woozy face',
    fallback: '🥴',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11195,
    representation: {
      x: 396,
      y: 132,
      width: 64,
      height: 64,
      xIndex: 6,
      yIndex: 2,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':woozy:',
  },
  {
    id: '1f448',
    name: 'backhand index pointing left',
    fallback: '👈',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11196,
    representation: {
      x: 1122,
      y: 330,
      width: 64,
      height: 64,
      xIndex: 17,
      yIndex: 5,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':point-left:',
  },
  {
    id: '1f4a9',
    name: 'pile of poo',
    fallback: '💩',
    type: 'STANDARD',
    category: 'PEOPLE',
    order: 11197,
    representation: {
      x: 1320,
      y: 132,
      width: 64,
      height: 64,
      xIndex: 20,
      yIndex: 2,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
    },
    searchable: true,
    shortName: ':poo:',
  },
  {
    id: '2705',
    name: 'check mark button',
    fallback: '✅',
    type: 'STANDARD',
    category: 'SYMBOLS',
    order: 11198,
    representation: {
      x: 396,
      y: 330,
      width: 64,
      height: 64,
      xIndex: 6,
      yIndex: 5,
      spriteRef:
        'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/symbols.png',
    },
    searchable: true,
    shortName: ':check:',
  },
];

export const meta: any = {
  spriteSheets: {
    'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/nature.png':
      {
        url: 'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/nature.png',
        row: 13,
        column: 14,
        height: 858,
        width: 924,
      },
    'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/symbols.png':
      {
        url: 'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/symbols.png',
        row: 17,
        column: 19,
        height: 1122,
        width: 1254,
      },
    'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/activity.png':
      {
        url: 'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/activity.png',
        row: 18,
        column: 19,
        height: 1188,
        width: 1254,
      },
    'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/flags.png':
      {
        url: 'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/flags.png',
        row: 16,
        column: 17,
        height: 1056,
        width: 1122,
      },
    'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png':
      {
        url: 'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/people.png',
        row: 36,
        column: 37,
        height: 2376,
        width: 2442,
      },
    'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/places.png':
      {
        url: 'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/places.png',
        row: 11,
        column: 12,
        height: 726,
        width: 792,
      },
    'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/objects.png':
      {
        url: 'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/objects.png',
        row: 14,
        column: 15,
        height: 924,
        width: 990,
      },
    'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/foods.png':
      {
        url: 'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/standard/a51a7674-8d5d-4495-a2d2-a67c090f5c3b/64x64/spritesheets/foods.png',
        row: 10,
        column: 11,
        height: 660,
        width: 726,
      },
  },
};
